import '../../styles/game/GameRules.css';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';




function GameRules({ isOpen, onClose, ProvablyOpen }) {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => {
                setIsVisible(true);
            }, 10);
        } else {
            setIsVisible(false);
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);

    return (
        <>
            <div className={`modalWrapper ${isVisible ? "show" : "fade-out"}`}
                 onClick={() => {
                     setTimeout(() => setIsVisible(false), 10);
                     onClose();
                 }}>
            </div>
            <div className={`gameRulesModal ${isVisible ? "show" : "fade-out"}`} onClick={() => {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }}>
                <div className={`gameRulesWrapper ${isVisible ? "show" : "fade"}`}>
                    <div className={'gameRulesContent'} onClick={(e) => e.stopPropagation()}>
                        <div className={'gameRulesHeader'}>
                            <span>{t("gameRules").toUpperCase()}</span>
                            <button className={'gameRulesCloseBtn'} onClick={() => {
                                setTimeout(() => setIsVisible(false), 10);
                                onClose();
                            }}>
                                <span>×</span>
                            </button>
                        </div>
                        <div className={'gameRulesBody'}>
                            <p className={'mb-16'}>{t("bodyTitle")}</p>
                            <p className={'provably-fair-modal-link'} onClick={ProvablyOpen}>{t("provablyFairText")}</p>
                            <h6 className={'gameRules-h6'}>{t("howToPlayComponent.howToPlay")}</h6>
                            <div className={"youtube-embed"}>
                                <iframe src="https://www.youtube.com/embed/PZejs3XDCSY"
                                        title="Spribe Aviator - How to play?" frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                            </div>
                            <div className={'gameRulesStepsWrapper'}>
                                <h6 className={'gameRulesSteps-title'}>Aviator is as easy to play as 1-2-3</h6>
                                <div className={'steps-container'}>
                                    <div className={'rules-step step-1'}>
                                        <h3 className={'step-title'}>
                                            01
                                        </h3>
                                        <div className={'step-img'}>
                                            <img src="/assets/img/rules-step-1.png" alt=""/>
                                        </div>
                                        <div className={'rules-step-text'}>
                                            <img src="/assets/img/01-bet.svg" alt=""/>
                                            <span>{t("step1Title")}</span>
                                            <p>{t("step1Text")}</p>
                                        </div>
                                    </div>
                                    <div className={'rules-step step-2'}>
                                        <h3 className={'step-title'}>
                                            02
                                        </h3>
                                        <div className={'step-img'}>
                                            <img src="/assets/img/rules-step-02.png" alt=""/>
                                        </div>
                                        <div className={'rules-step-text2'}>
                                            <img src="/assets/img/01-bet.svg" alt=""/>
                                            <p><span>{t("step2Title")}</span> {t("step2Text")}</p>
                                        </div>
                                    </div>
                                    <div className={'rules-step step-3'}>
                                        <h3 className={'step-title'}>
                                            03
                                        </h3>
                                        <div className={'step-img'}>
                                            <img src="/assets/img/rules-step-3.png" alt=""/>
                                        </div>
                                        <div className={'rules-step-text2'}>
                                            <img src="/assets/img/01-bet.svg" alt=""/>
                                            <p><span>{t("step3Title")}</span>{t("step3Text")}</p>
                                        </div>
                                    </div>
                                </div>
                                <p className={'mt-20 mb-16 text-grey'}>{t("underStepsText")}</p>
                                <div className={'rules-list'}>
                                    <div className={'rules-list-title'}>{t("moreDetails")}</div>
                                    <ul className={'rules-list-group'}>
                                        <li className={'rules-list-group-item'}>{t("moreDetailsListItem1")}</li>
                                        <li className={'rules-list-group-item'}>{t("moreDetailsListItem2")}</li>
                                        <li className={'rules-list-group-item'}>
                                            {t("moreDetailsListItem3")}
                                            <img className={'rules-verify-img'} src="/assets/img/verify.svg" alt=""/>
                                            {t("moreDetailsListItem4")}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <h6 className={'gameFunctionsTitle'}>{t("gameFunctions").toUpperCase()}</h6>
                            <div className={'game-functions-list'}>
                                <div className={'rules-list-title'}>{t("betCashOut")}</div>
                                <ul className={'rules-list-group'}>
                                    <li className={'rules-list-group-item'}>{t("betCashOutListItem1")}</li>
                                    <li className={'rules-list-group-item'}>{t("betCashOutListItem2")}</li>
                                    <li className={'rules-list-group-item'}>{t("betCashOutListItem3")}</li>
                                    <li className={'rules-list-group-item'}>{t("betCashOutListItem4")}</li>
                                    <li className={'rules-list-group-item'}>{t("betCashOutListItem5")}</li>
                                    <li className={'rules-list-group-item'}>{t("betCashOutListItem6")}</li>
                                </ul>
                            </div>
                            <div className={'game-functions-list'}>
                                <div className={'rules-list-title'}>{t("autoPlayTitle")}</div>
                                <ul className={'rules-list-group'}>
                                    <li className={'rules-list-group-item'}>{t("autoPlayListItem1")}</li>
                                    <li className={'rules-list-group-item'}>{t("autoPlayListItem2")}</li>
                                    <li className={'rules-list-group-item'}>{t("autoPlayListItem3")}</li>
                                </ul>
                            </div>
                            <div className={'game-functions-list'}>
                                <div className={'rules-list-title'}>{t("liveBetStatistics")}</div>
                                <ul className={'rules-list-group'}>
                                    <li className={'rules-list-group-item'}>{t("liveBetStatisticsListItem1")}</li>
                                    <li className={'rules-list-group-item'}>{t("liveBetStatisticsListItem2")}</li>
                                    <li className={'rules-list-group-item'}>{t("liveBetStatisticsListItem3")}</li>
                                </ul>
                            </div>
                            <div className={'game-functions-list'}>
                                <div className={'rules-list-title'}>{t("inGameChat")}</div>
                                <ul className={'rules-list-group'}>
                                    <li className={'rules-list-group-item'}>{t("inGameChatListItem")}</li>
                                </ul>
                            </div>
                            <div className={'game-functions-list'}>
                                <div className={'rules-list-title'}>{t("freeBets")}</div>
                                <ul className={'rules-list-group'}>
                                    <li className={'rules-list-group-item'}>{t("freeBetsListItem")}</li>
                                </ul>
                            </div>
                            <div className={'game-functions-list'}>
                                <div className={'rules-list-title'}>{t("rainFeature")}</div>
                                <ul className={'rules-list-group'}>
                                    <li className={'rules-list-group-item'}>{t("rainFeatureListItem")}</li>
                                </ul>
                            </div>
                            <div className={'game-functions-list'}>
                                <div className={'rules-list-title'}>{t("randomisation")}</div>
                                <ul className={'rules-list-group'}>
                                    <li className={'rules-list-group-item'}>
                                        {t("randomisationListItem1")}
                                        <span className={'provably-fair-modal-link ml-4'} onClick={ProvablyOpen}>{t("provablyFairText")}</span>
                                    </li>
                                    <li className={'rules-list-group-item'}>{t("randomisationListItem2")}</li>
                                    <li className={'rules-list-group-item'}>
                                        {t("randomisationListItem3")}
                                        <img className={'rules-verify-img'} src="/assets/img/verify.svg" alt=""/>
                                        {t("randomisationListItem4")}
                                    </li>
                                </ul>
                            </div>
                            {/*<div className={'game-functions-list'}>*/}
                            {/*    <div className={'rules-list-title'}>{t("returnToPlayer")}</div>*/}
                            {/*    <ul className={'rules-list-group'}>*/}
                            {/*        <li className={'rules-list-group-item'}>{t("returnToPlayerListItem")}</li>*/}
                            {/*    </ul>*/}
                            {/*</div>*/}
                            <div className={'game-functions-list'}>
                                <div className={'rules-list-title'}>{t("gameMenu")}</div>
                                <ul className={'rules-list-group'}>
                                    <li className={'rules-list-group-item'}>{t("gameMenuListItem1")}</li>
                                    <li className={'rules-list-group-item'}>{t("gameMenuListItem2")}</li>
                                    <li className={'rules-list-group-item'}>{t("gameMenuListItem3")}</li>
                                    <li className={'rules-list-group-item'}>{t("gameMenuListItem4")}</li>
                                    <li className={'rules-list-group-item'}>{t("gameMenuListItem5")}</li>
                                    <li className={'rules-list-group-item'}>{t("gameMenuListItem6")}</li>
                                    <li className={'rules-list-group-item'}>{t("gameMenuListItem7")}</li>
                                </ul>
                            </div>
                            {/*<div className={'game-functions-list'}>*/}
                            {/*    <div className={'rules-list-title'}>{t("multiServers")}</div>*/}
                            {/*    <ul className={'rules-list-group'}>*/}
                            {/*        <li className={'rules-list-group-item'}>{t("multiServersListItem1")}</li>*/}
                            {/*        <li className={'rules-list-group-item'}>{t("multiServersListItem2")}</li>*/}
                            {/*    </ul>*/}
                            {/*</div>*/}
                            <div className={'game-functions-list'}>
                                <div className={'rules-list-title'}>{t("other")}</div>
                                <ul className={'rules-list-group'}>
                                    <li className={'rules-list-group-item'}>{t("otherListItem1")}</li>
                                    <li className={'rules-list-group-item'}>{t("otherListItem2")}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default GameRules;